// ─── SIGHT WORDS ─────────────────────────────────────────────
let _demoSightWords = [
  { id: 'sw1', word: 'HELLO' },
  { id: 'sw2', word: 'WORLD' },
  { id: 'sw3', word: 'SCHOOL' },
  { id: 'sw4', word: 'FRIEND' },
  { id: 'sw5', word: 'FAMILY' },
];
export const getDemoSightWords = () => _demoSightWords;
export function addDemoSightWord(word) {
  const entry = { id: 'sw-' + Date.now(), word: word.trim().toUpperCase() };
  _demoSightWords = [..._demoSightWords, entry];
  return entry;
}
export function deleteDemoSightWord(id) {
  _demoSightWords = _demoSightWords.filter((w) => w.id !== id);
}

// ─── SCRAMBLE WORDS ──────────────────────────────────────────
let _demoScrambleWords = [
  { id: 'sc1', word: 'CAT',  scrambled: 'TAC' },
  { id: 'sc2', word: 'DOG',  scrambled: 'GOD' },
  { id: 'sc3', word: 'HAT',  scrambled: 'ATH' },
  { id: 'sc4', word: 'SUN',  scrambled: 'NUS' },
  { id: 'sc5', word: 'FISH', scrambled: 'SHFI' },
];
export const getDemoScrambleWords = () => _demoScrambleWords;
export function addDemoScrambleWord(word, scrambled) {
  const entry = {
    id: 'sc-' + Date.now(),
    word: word.trim().toUpperCase(),
    scrambled: scrambled.trim().toUpperCase(),
  };
  _demoScrambleWords = [..._demoScrambleWords, entry];
  return entry;
}
export function deleteDemoScrambleWord(id) {
  _demoScrambleWords = _demoScrambleWords.filter((w) => w.id !== id);
}

// ─── CATEGORY WORDS ──────────────────────────────────────────
let _demoCategoryWords = [
  { id: 'cw1', word: 'APPLE', correct_category: 'FRUIT',   distractors: ['FOOD'] },
  { id: 'cw2', word: 'CAR',   correct_category: 'VEHICLE', distractors: ['TOY'] },
  { id: 'cw3', word: 'BALL',  correct_category: 'SPORT',   distractors: ['TOY'] },
  { id: 'cw4', word: 'ROSE',  correct_category: 'FLOWER',  distractors: ['PLANT'] },
  { id: 'cw5', word: 'LION',  correct_category: 'ANIMAL',  distractors: ['BIRD'] },
];
export const getDemoCategoryWords = () => _demoCategoryWords;
export function addDemoCategoryWord(word, correctCategory, distractors) {
  const entry = {
    id: 'cw-' + Date.now(),
    word: word.trim().toUpperCase(),
    correct_category: correctCategory.trim().toUpperCase(),
    distractors: distractors.map((d) => d.trim().toUpperCase()),
  };
  _demoCategoryWords = [..._demoCategoryWords, entry];
  return entry;
}
export function deleteDemoCategoryWord(id) {
  _demoCategoryWords = _demoCategoryWords.filter((w) => w.id !== id);
}

// ─── STUDENTS ────────────────────────────────────────────────
let _demoStudents = [
  {
    id: 'demo-student-001',
    first_name: 'Alex',
    last_name: 'Student',
    username: 'student_demo',
    email: 'student@demo.local',
    role: 'student',
    is_active: true,
  },
  {
    id: 'demo-student-002',
    first_name: 'Jamie',
    last_name: 'Learner',
    username: 'jamie_l',
    email: 'jamie@demo.local',
    role: 'student',
    is_active: false,
  },
];
export const getDemoStudents = () => _demoStudents;
export function setDemoStudentActive(userId, isActive) {
  _demoStudents = _demoStudents.map((s) =>
    s.id === userId ? { ...s, is_active: isActive } : s
  );
}

// ─── WORD ASSIGNMENTS (per-student Maps) ─────────────────────
// Pre-seeded so demo-student-001 sees all demo words on first load.
let _demoSightAssignments = new Map([
  ['demo-student-001', new Set(_demoSightWords.map((w) => w.id))],
]);
let _demoScrambleAssignments = new Map([
  ['demo-student-001', new Set(_demoScrambleWords.map((w) => w.id))],
]);
let _demoCategoryAssignments = new Map([
  ['demo-student-001', new Set(_demoCategoryWords.map((w) => w.id))],
]);

// ── Sight assignments ──
export function getDemoAssignedSightIds(studentId) {
  return [...(_demoSightAssignments.get(studentId) || new Set())];
}
export function assignDemoSightWord(studentId, wordId) {
  if (!_demoSightAssignments.has(studentId)) _demoSightAssignments.set(studentId, new Set());
  _demoSightAssignments.get(studentId).add(wordId);
}
export function unassignDemoSightWord(studentId, wordId) {
  (_demoSightAssignments.get(studentId) || new Set()).delete(wordId);
}

// ── Scramble assignments ──
export function getDemoAssignedScrambleIds(studentId) {
  return [...(_demoScrambleAssignments.get(studentId) || new Set())];
}
export function assignDemoScrambleWord(studentId, wordId) {
  if (!_demoScrambleAssignments.has(studentId)) _demoScrambleAssignments.set(studentId, new Set());
  _demoScrambleAssignments.get(studentId).add(wordId);
}
export function unassignDemoScrambleWord(studentId, wordId) {
  (_demoScrambleAssignments.get(studentId) || new Set()).delete(wordId);
}

// ── Category assignments ──
export function getDemoAssignedCategoryIds(studentId) {
  return [...(_demoCategoryAssignments.get(studentId) || new Set())];
}
export function assignDemoCategoryWord(studentId, wordId) {
  if (!_demoCategoryAssignments.has(studentId)) _demoCategoryAssignments.set(studentId, new Set());
  _demoCategoryAssignments.get(studentId).add(wordId);
}
export function unassignDemoCategoryWord(studentId, wordId) {
  (_demoCategoryAssignments.get(studentId) || new Set()).delete(wordId);
}

// ─── MATH CONCEPTS ────────────────────────────────────────────
let _demoMathConcepts = [
  { id: 'mc1', stage: 'concrete',         type: 'counting',     question: 'How many stars do you see?',       visual: '⭐⭐⭐',     dots: null, expression: null, answer: 3, choices: [1,2,3,4], display_order: 1 },
  { id: 'mc2', stage: 'concrete',         type: 'counting',     question: 'How many apples are there?',       visual: '🍎🍎🍎🍎🍎', dots: null, expression: null, answer: 5, choices: [3,4,5,6], display_order: 2 },
  { id: 'mc3', stage: 'representational', type: 'dots',         question: 'How many dots are there?',         visual: null, dots: 2,    expression: null, answer: 2, choices: [1,2,3,4], display_order: 3 },
  { id: 'mc4', stage: 'abstract',         type: 'addition',     question: 'What is 1 plus 1?',                visual: null, dots: null, expression: '1 + 1 = ?', answer: 2, choices: [1,2,3,4], display_order: 4 },
  { id: 'mc5', stage: 'abstract',         type: 'subtraction',  question: 'What is 5 minus 2?',               visual: null, dots: null, expression: '5 - 2 = ?', answer: 3, choices: [2,3,4,5], display_order: 5 },
];
export const getDemoMathConcepts = () => _demoMathConcepts;
export function addDemoMathConcept(stage, type, question, visual, dots, expression, answer, choices) {
  const entry = {
    id: 'mc-' + Date.now(),
    stage, type, question,
    visual: visual || null,
    dots: dots != null ? parseInt(dots, 10) : null,
    expression: expression || null,
    answer: parseInt(answer, 10),
    choices: choices.map(Number),
    display_order: _demoMathConcepts.length + 1,
  };
  _demoMathConcepts = [..._demoMathConcepts, entry];
  return entry;
}
export function deleteDemoMathConcept(id) {
  _demoMathConcepts = _demoMathConcepts.filter((c) => c.id !== id);
}

// ── Math assignments ──
let _demoMathAssignments = new Map([
  ['demo-student-001', new Set(_demoMathConcepts.map((c) => c.id))],
]);
export function getDemoAssignedMathIds(studentId) {
  return [...(_demoMathAssignments.get(studentId) || new Set())];
}
export function assignDemoMathConcept(studentId, conceptId) {
  if (!_demoMathAssignments.has(studentId)) _demoMathAssignments.set(studentId, new Set());
  _demoMathAssignments.get(studentId).add(conceptId);
}
export function unassignDemoMathConcept(studentId, conceptId) {
  (_demoMathAssignments.get(studentId) || new Set()).delete(conceptId);
}

// ─── DAILY LIVING SCENARIOS ────────────────────────────────────
// Mirrors the "Washing Hands" pilot scenario seeded by
// supabase/migrations/add-daily-living-tables.sql exactly (same steps shape).
let _demoDailyLivingScenarios = [
  {
    id: 'dl1',
    title: 'Washing Hands',
    category: 'hygiene',
    difficulty: 1,
    display_order: 1,
    steps: [
      { order: 1, instruction: 'Turn on the water',        image: 'fa-faucet',     options: ['Turn on the water', 'Turn off the lights', 'Open the door'], correct_option: 0, voice_prompt: true },
      { order: 2, instruction: 'Put soap on your hands',   image: 'fa-pump-soap',  options: ['Put soap on your hands', 'Drink the water', 'Dry your hands'], correct_option: 0, voice_prompt: true },
      { order: 3, instruction: 'Rub your hands together',  image: 'fa-hands-wash', options: ['Rub your hands together', 'Turn off the water', 'Put on soap'], correct_option: 0, voice_prompt: true },
      { order: 4, instruction: 'Rinse the soap off',        image: 'fa-faucet',     options: ['Rinse the soap off', 'Add more soap', 'Walk away'], correct_option: 0, voice_prompt: true },
      { order: 5, instruction: 'Dry your hands with a towel', image: 'fa-wind',    options: ['Dry your hands with a towel', 'Wash again', 'Turn the water back on'], correct_option: 0, voice_prompt: true },
    ],
  },
];
export const getDemoDailyLivingScenarios = () => _demoDailyLivingScenarios;
export function addDemoDailyLivingScenario(title, category, difficulty, steps) {
  const entry = {
    id: 'dl-' + Date.now(),
    title: title.trim(),
    category,
    difficulty: parseInt(difficulty, 10) || 1,
    display_order: _demoDailyLivingScenarios.length + 1,
    steps,
  };
  _demoDailyLivingScenarios = [..._demoDailyLivingScenarios, entry];
  return entry;
}
export function deleteDemoDailyLivingScenario(id) {
  _demoDailyLivingScenarios = _demoDailyLivingScenarios.filter((s) => s.id !== id);
}

// ── Daily Living assignments (pre-seeded so demo-student-001 sees Washing Hands) ──
let _demoDailyLivingAssignments = new Map([
  ['demo-student-001', new Set(['dl1'])],
]);
export function getDemoAssignedDailyLivingIds(studentId) {
  return [...(_demoDailyLivingAssignments.get(studentId) || new Set())];
}
export function assignDemoDailyLivingScenario(studentId, scenarioId) {
  if (!_demoDailyLivingAssignments.has(studentId)) _demoDailyLivingAssignments.set(studentId, new Set());
  _demoDailyLivingAssignments.get(studentId).add(scenarioId);
}
export function unassignDemoDailyLivingScenario(studentId, scenarioId) {
  (_demoDailyLivingAssignments.get(studentId) || new Set()).delete(scenarioId);
}

// ── Daily Living resume state (current_step per student+scenario) ──
let _demoDailyLivingProgress = new Map([
  ['demo-student-001', { dl1: 1 }],
]);
export function getDemoDailyLivingProgress(studentId) {
  return _demoDailyLivingProgress.get(studentId) || {};
}
export function setDemoDailyLivingCurrentStep(studentId, scenarioId, stepNumber) {
  const existing = _demoDailyLivingProgress.get(studentId) || {};
  _demoDailyLivingProgress.set(studentId, { ...existing, [scenarioId]: stepNumber });
}

// ── Daily Living step-attempt log (session-only, in-memory) ──
let _demoDailyLivingLog = [];
export function addDemoDailyLivingLogEntry(studentId, scenarioId, stepNumber, correct, attemptsUsed, hintTierReached) {
  _demoDailyLivingLog = [..._demoDailyLivingLog, {
    student_id: studentId,
    scenario_id: scenarioId,
    step_number: stepNumber,
    correct,
    attempts_used: attemptsUsed,
    hint_tier_reached: hintTierReached,
    completed_at: new Date().toISOString(),
  }];
}
export function getDemoDailyLivingLog(studentId) {
  return _demoDailyLivingLog.filter((r) => r.student_id === studentId);
}

// ── Daily Living completions (repeatable — array, no unique constraint) ──
let _demoDailyLivingCompletions = [];
export function addDemoDailyLivingCompletion(studentId, scenarioId) {
  _demoDailyLivingCompletions = [..._demoDailyLivingCompletions, {
    student_id: studentId,
    scenario_id: scenarioId,
    completed_at: new Date().toISOString(),
  }];
}
export function getDemoDailyLivingCompletions(studentId) {
  return _demoDailyLivingCompletions.filter((r) => r.student_id === studentId);
}

// ─── DEMO ACHIEVEMENTS (mutable, so first_life_skill can unlock live in demo mode) ──
let _demoAchievements = new Map([
  ['demo-student-001', new Set(['first_word', 'streak_3', 'brain_buster', 'quick_solver'])],
]);
export function getDemoAchievements(studentId) {
  return [...(_demoAchievements.get(studentId) || new Set())];
}
export function addDemoAchievement(studentId, badgeKey) {
  if (!_demoAchievements.has(studentId)) _demoAchievements.set(studentId, new Set());
  _demoAchievements.get(studentId).add(badgeKey);
}
